// Recensioni reali tratte dal profilo Google di Doga Parquet.
// Profilo: https://www.google.com/maps/place/Doga+Parquet/

export const googleRating = {
    average: 5.0,
    count: 35,
    profileUrl:
        "https://www.google.com/maps/place/Doga+Parquet/@36.9138013,14.7352628,11z/data=!4m8!3m7!1s0x2c7e4b913084dd09:0xb56e25d751607c7!8m2!3d36.9139156!4d14.900413!9m1!1b1!16s%2Fg%2F11y1zxdmbt",
    placeholder: false,
};

export const reviews = [
    {
        id: "r-mino",
        author: "Christian Ivano Mino",
        badge: "Local Guide",
        rating: 5,
        date: "3 settimane fa",
        text:
            "Ottimo servizio, puntuale, preciso e molto pulito. Sempre attento alle necessità del cliente, ha sempre fornito ottimi consigli su come trattare e mantenere il parquet. Il montaggio è stato veloce e preciso. Anche il prezzo è stato molto buono, quindi non posso fare altro che consigliarlo.",
    },
    {
        id: "r-magnano",
        author: "Chiara Magnano",
        rating: 5,
        date: "1 mese fa",
        text:
            "Gianluca ha installato il Deco Clap sulla nostra scala in granito, dandole una nuova vita ed è stato semplicemente bravissimo. Preciso, minuzioso, pulito e attento ad ogni dettaglio. Ha fatto un lavoro a regola d'arte. Il risultato parla da sé. Non potevamo scegliere di meglio. Consigliatissimo!",
    },
    {
        id: "r-cina",
        author: "Mery64 Cinà",
        badge: "Local Guide",
        rating: 5,
        date: "2 mesi fa",
        text:
            "Se cercate la perfezione, chiamate Gianluca. Mi ha posato un parquet SPC in modo magistrale. Puntualità, precisione e pulizia sono i suoi punti di forza. Si vede subito che è un esperto del settore: un lavoro ben curato fin nei minimi dettagli.",
    },
    {
        id: "r-peluso",
        author: "Valeria Peluso",
        rating: 5,
        date: "3 mesi fa",
        text:
            "Gianluca è un professionista, una persona affidabile, attenta, precisa. Offre degli ottimi consigli. Messa in posa super scrupolosa e veloce. Consigliatissimo!",
    },
    {
        id: "r-castellino",
        author: "Riccardo Castellino",
        rating: 5,
        date: "3 mesi fa",
        text:
            "Mi sono rivolto a Doga Parquet per far montare dei pannelli modulari sul muro e sono davvero soddisfatto. Gianluca è stato gentilissimo, preciso e si vede che sa quello che fa. Il lavoro è venuto benissimo e ha dato un tocco davvero bello.",
    },
    {
        id: "r-caligiore",
        author: "Sara Caligiore",
        rating: 5,
        date: "3 mesi fa",
        text:
            "Gianluca ha fatto un lavoro eccezionale! Ha lavorato con cura e attenzione ai minimi dettagli, è stato disponibile e gentile. Ha lasciato la nostra casa immacolata e pulita. Siamo davvero soddisfatti e felici del risultato ottenuto. Lo consigliamo vivamente a tutti!",
    },
    {
        id: "r-caccamo",
        author: "Maurizio Caccamo",
        badge: "Local Guide",
        rating: 5,
        date: "4 mesi fa",
        text:
            "Doppia esperienza eccellente. Gianluca riesce a trovare sempre la soluzione, con precisione e gusto, frutto di tanta esperienza e passione nel suo lavoro. Consigliatissimo.",
    },
    {
        id: "r-maiorca",
        author: "Sebastiano Maiorca",
        rating: 5,
        date: "5 mesi fa",
        text:
            "Lavoro eccellente sotto ogni punto di vista. Il parquet è venuto splendido e ha valorizzato tantissimo l'appartamento. Grande professionalità, precisione e passione per il proprio lavoro. È raro trovare artigiani così bravi e affidabili. Assolutamente consigliato!",
    },
    {
        id: "r-schembari",
        author: "Saro Schembari",
        rating: 5,
        date: "6 mesi fa",
        text:
            "Esperienza decisamente positiva. Professionalità e gentilezza: sono questi gli aggettivi che mi vengono in mente per descrivere la bella persona che è Gianluca. Grazie di tutto! Alla prossima.",
    },
    {
        id: "r-ascolese",
        author: "Antonio Ascolese",
        rating: 5,
        date: "9 mesi fa",
        text:
            "In quattro giorni la mia casa è stata trasformata! Nonostante l'arredamento preesistente, Gianluca è riuscito a installare 100 mq di un bellissimo pavimento in SPC Deco Clap 3D e un battiscopa bianco in PVC.",
    },
    {
        id: "r-cocci",
        author: "Mariarita Cocci",
        rating: 5,
        date: "un anno fa",
        text:
            "Gianluca è grande professionista! Oltre ad essere un eccellente parchettista, preciso, pulito e veloce nell'esecuzione dei lavori, è una gran bella persona, seria ed affidabile. Ad oggi una vera rarità. Nel mio caso, ha realizzato un lavoro molto certosino nei tempi pattuiti.",
    },
    {
        id: "r-randazzo",
        author: "Raffaele Randazzo",
        rating: 5,
        date: "11 mesi fa",
        text:
            "Ottima esperienza. Grande professionalità, puntualità, precisione e pulizia. Gianluca ha installato in maniera eccellente questo rivestimento modulare in una parete del nostro bagno. Consiglio assolutamente!",
    },
];
